export default __webpack_public_path__ + "static/media/icon_logo_mark.49a20246.png";